// extracted by mini-css-extract-plugin
export var avatarContainer = "_bl-0";
export var avatarTypingWave = "_bl-i";
export var gray = "_bl-f";
export var green = "_bl-c";
export var icon = "_bl-9";
export var image = "_bl-1";
export var lg = "_bl-6";
export var md = "_bl-5";
export var presenceDot = "_bl-b";
export var red = "_bl-d";
export var sm = "_bl-4";
export var status = "_bl-a";
export var typingDot = "_bl-h";
export var typingPill = "_bl-g";
export var xl = "_bl-7";
export var xs = "_bl-3";
export var xxl = "_bl-8";
export var xxs = "_bl-2";
export var yellow = "_bl-e";